import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Shipping } from './shipping.entity';

export class CreateShippingDto extends Omit(Shipping, [...BaseEntityFieldsArray, 'status'], ['status']) {}
